export enum EMealSharedPortion {
	ALL = 'all',
}

export enum EMealAddonPortion {
	ALL = 'all',
}

export const MealCombinedNameMapper: Record<EMealSize | EMealPrepPortions, string> = {
	[EMealSize.ALL]: 'Wszystkie',
	[EMealSize.S_SIZE]: 'Rozmiar S',
	[EMealSize.M_SIZE]: 'Rozmiar M',
	[EMealSize.L_SIZE]: 'Rozmiar L',
	[EMealSize.XL_SIZE]: 'Rozmiar XL',
	[EMealPrepPortions.ONE_PORTION]: '1 porcja',
	[EMealPrepPortions.TWO_PORTIONS]: '2 porcje',
	[EMealPrepPortions.THREE_PORTIONS]: '3 porcje',
	[EMealPrepPortions.FOUR_PORTIONS]: '4 porcje',
	[EMealPrepPortions.FIVE_PORTIONS]: '5 porcji',
	[EMealPrepPortions.SIX_PORTIONS]: '6 porcji',
}

export enum EDietMealSearchType {
	MEAL = 'meal',
	MEALPREP = 'prep_meal',
	ADDONS = 'addons',
	ADDON_MEAL = 'addon_meal',
	ADDON_MEAL_PREP = 'addon_prep_meal',
}

export enum EDietRelatedType {
	MEAL_TO_MEALPREP = 'meal_to_meal_prep',
	MEALPREP_TO_MEAL = 'meal_prep_to_meal',
	VEGETARIAN = 'vegetarian',
	NON_VEGETARIAN = 'non_vegetarian',
	SIMILAR = 'similar',
}

/**
 * Search components
 */
export enum EDietSearchComponentsFilter {
	NAME = 'name',
	INTERNAL_NAME = 'internal_name',
	WAREHOUSE_NAME = 'warehouse_name',
}

/**
 * Component types
 */
export enum EDietSharedComponentType {
	SEMIPRODUCT = 'dietary_semi_product',
	MATERIAL = 'dietary_raw_material',
	GROUP = 'dietary_group',
}
